import { render, staticRenderFns } from "./msTr.vue?vue&type=template&id=0a678a61&scoped=true"
import script from "./msTr.vue?vue&type=script&lang=js"
export * from "./msTr.vue?vue&type=script&lang=js"
import style0 from "./msTr.vue?vue&type=style&index=0&id=0a678a61&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a678a61",
  null
  
)

export default component.exports